module.exports = __webpack_public_path__ + "static/media/recurit_card_img.f4dc11d0.png";